import React from "react"

const CartItem = ({ item, index, updateCart }) => {
    const product = item?.product || {}
    const category = product?.category || ''
    const qty = parseInt(item?.quantity, 10) || 1
    const price = parseFloat(item?.price) || 0
    const totalLine = (price * qty).toFixed(2)

    return (
        <div className="cart-item">
            <i className="remove-item bi bi-trash mr-3" onClick={() => updateCart({ index: index, quantity: 0 })} onKeyDown={() => updateCart({ index: index, quantity: 0 })} role="presentation"></i>
            <h4>The <span className="brand">plumes</span> {category}</h4>
            <h6 className="text-primary">
                {category === 'Pillow' ? (product.types?.[item.type]?.material || 'Pillow') : (product.name || category)}
                {(category === 'Mattress' || category === 'Futon Mattress') && item.selectedSize && <> | <span style={{ fontSize: '12px', color: '#333' }}>{item.selectedSize[1]} Inch X {item.selectedSize[0]} Inch X {item.thick} Inch {item.size ? `(${item.size})` : ''}</span></>}
                {(category === 'Protector' || category === 'Bedspread') && item.selectedSize && <> | <span style={{ fontSize: '12px', color: '#333' }}>{item.selectedSize[1]} Inch X {item.selectedSize[0]} Inch</span> {item.color?.name ? <>| <span style={{ fontSize: '12px', color: '#333' }}>{item.color.name}</span></> : null}</>}
                {category === 'Pillow' && product.types?.[item.type]?.size && <> | <span style={{ fontSize: '12px', color: '#333' }}>{product.types[item.type].size[0]}cm X {product.types[item.type].size[1]}cm</span></>}
                {category === 'Eye Mask' && item.color?.name && <> | <span style={{ fontSize: '12px', color: '#333' }}>{item.color.name}</span></>}
            </h6>
            
            <div className="d-flex align-items-center">
                <i className={(qty <= 1 ? 'disabled ' : '') + 'bi bi-dash-circle-fill text-info h5'} onClick={() => updateCart({ index: index, quantity: Math.max(1, qty - 1) })} role="presentation"></i>
                <span className="h5" style={{ width: '50px', textAlign: 'center' }}>{qty}</span>
                <i className="bi bi-plus-circle-fill text-info h5" onClick={() => updateCart({ index: index, quantity: qty + 1 })} onKeyDown={() => updateCart({ index: index, quantity: qty + 1 })} role="presentation"></i>
                <h4 className="text-info mx-2"><span style={{ color: '#ccc' }}>|</span> ₹{totalLine}</h4>
            </div>
        </div>
    )
}

export default CartItem